import { render, staticRenderFns } from "./PickTheAnswerDropdown.vue?vue&type=template&id=64493134&scoped=true&"
import script from "./PickTheAnswerDropdown.vue?vue&type=script&lang=ts&"
export * from "./PickTheAnswerDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./PickTheAnswerDropdown.vue?vue&type=style&index=0&id=64493134&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64493134",
  null
  
)

export default component.exports